import { ICreateCentroCustoUseCase } from "../../../presentation/useCases/create/create_centro_custo_use_case";
import { CentroCusto } from "../../models/centro_custo";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateCentroCustoUseCase
 */

export class CreateCentroCustoUseCase implements ICreateCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async createCentroCusto(
    status: number,
    codigo: string,
    descricao: string,
    bdi?: number | null,
    bdi2?: number | null,
    numeroCno?: string,
    obsCentroCusto?: string
  ): Promise<CentroCusto> {
    const result = this.repository.createCentroCusto(
      status = status,
      codigo = codigo,
      descricao = descricao,
      bdi = bdi,
      bdi2 = bdi2,
      numeroCno = numeroCno,
      obsCentroCusto = obsCentroCusto);
    return result;

  }

}
